// extracted by mini-css-extract-plugin
export var calendarView = "_ik-0";